<script>
import { ref, onMounted, watch, computed } from "vue";
// import Logo from "./components/Logo.vue";
// import LoadingFrame from "./components/LoadingFrame.vue";
// import Indicator from "./components/Indicator.vue";
// import Footer from "./components/Footer.vue";
// import FirstCut from "./components/FirstCut.vue";
// import SecondCut from "./components/SecondCut.vue";
import ThirdCut from "./components/ThirdCut.vue";
export default {
	components: {
		// Logo,
		// LoadingFrame,
		// Indicator,
		// FirstCut,
		// SecondCut,
		ThirdCut,
		// Footer,
	},
	setup() {
		const scrollTop = ref(0);
		const windowWidth = ref(window.innerWidth);
		const windowHeight = ref(window.innerHeight);
		const videoReady = ref(false);

		const handleChangeState = (val) => {
			videoReady.value = val;
		};

		onMounted(() => {
			window.addEventListener("resize", () => {
				windowWidth.value = window.innerWidth;
				windowHeight.value = window.innerHeight;
			});
			document.body.addEventListener("scroll", (e) => {
				scrollTop.value = e.target.scrollTop;
			});
		});

		return {
			windowWidth,
			windowHeight,
			scrollTop,
			videoReady,
			handleChangeState,
		};
	},
};
</script>

<template>
	<!-- <Logo />
	<LoadingFrame @changeState="handleChangeState" /> -->
	<main>
		<!-- <FirstCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
			:videoReady="videoReady"
		/>
		<SecondCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
		/> -->
		<ThirdCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
		/>
	</main>
	<!-- <Indicator
		:windowHeight="windowHeight"
		:scrollTop="scrollTop"
		:videoReady="videoReady"
	/>
	<Footer /> -->
</template>

<style lang="scss">
$bfHeight: 50vh;
$bfHeight2: 30vh;
$rwdHeight1: 80vh;
$rwdHeight2: 70vh;
$rwdHeight3: 130vh;
$ratio1: 100vh / (800vh + 4 * $bfHeight);
$ratio2: 100vh / (800vh + 4 * $bfHeight + $rwdHeight1);
$ratio3: 100vh / (800vh + 4 * $bfHeight + $rwdHeight2);
$ratio4: 100vh / (800vh + 4 * $bfHeight + $rwdHeight3);
$mainH1: 800vh + 4 * $bfHeight;
$mainH2: 800vh + 4 * $bfHeight + $rwdHeight1;
$mainH3: 800vh + 4 * $bfHeight + $rwdHeight2;
$mainH4: 800vh + 4 * $bfHeight + $rwdHeight3;
$storyH: 200vh + $bfHeight;
$titleH: 100vh + $bfHeight;
$titleT: -100vh - $bfHeight;
$concepH: 300vh + $bfHeight;
$concepT: -200vh - $bfHeight;
$conceptH: 100vh + $bfHeight;
$conceptT: -300vh - 2 * $bfHeight;
$imgnH: 300vh + $bfHeight;
$imgnT: -400vh - 2 * $bfHeight;
$imgntH: 100vh + $bfHeight;
$imgntT: -500vh - 3 * $bfHeight;
$displayH1: 200vh + $bfHeight;
$displayH2: 200vh + $bfHeight + $rwdHeight1;
$displayH3: 200vh + $bfHeight + $rwdHeight2;
$displayH4: 200vh + $bfHeight + $rwdHeight3;
$seridispH: 150vh;
$displayT: -500vh - 3 * $bfHeight;

@font-face {
	font-family: "BMWTypeNextLatinTT-Bold";
	src: url("/bmw/4gc/teaser/font/BMWTypeNextLatinTT-Bold.woff") format("woff");
	font-display: swap;
}
@font-face {
	font-family: "BMWTypeNextLatinTT-Light";
	//src: url("/font/BMWTypeNextLatinTT-Light.woff") format("woff");
	src: url("/bmw/4gc/teaser/font/BMWTypeNextLatinTT-Light.woff")
		format("woff");
	font-display: swap;
}
@font-face {
	font-family: "BMWTypeNextLatinTT-Regular";
	src: url("/bmw/4gc/teaser/font/BMWTypeNextLatinTT-Regular.woff")
		format("woff");
	font-display: swap;
}
@font-face {
	font-family: "BMWTypeNextLatinTT-Thin";
	// src: url("/font/BMWTypeNextLatinTT-Light.woff") format("woff");
	src: url("/bmw/4gc/teaser/font/BMWTypeNextLatinTT-Thin.woff") format("woff");
	font-display: swap;
}
@font-face {
	font-family: arudjingxiheipe1xg30_hv;
	src: url("/bmw/4gc/teaser/font/arudjingxiheipe1xg30_hv.ttf")
		format("truetype");
	font-display: swap;
}
@font-face {
	font-family: arudjingxiheipe1xg30_md;
	src: url("/bmw/4gc/teaser/font/arudjingxiheipe1xg30_md.ttf")
		format("truetype");
	font-display: swap;
}

* {
	color: #fff;
	font-size: 0px;
}
h1,
h2,
p {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 0;
	font-weight: normal;
	vertical-align: baseline;
}
html,
body {
	width: 100%;
	height: 100%;
	margin: 0px;
	padding: 0px;
	font-size: 10px;
	background-color: #111;
	overflow: hidden;
}

#app {
	width: 100%;
	height: 100%;
	main {
		// height: $mainH1 * 1% / 1vh;
		// height: 1000vh;
		height: 100%;
		#story {
			height: $storyH * $ratio1 * 1% / 1vh;
			// height: 250vh;
			.sticky-wrapper {
				height: 100vh * 100% / $storyH;
				// height: 100vh;
			}
		}
		#title {
			height: $titleH * $ratio1 * 1% / 1vh;
			top: $titleT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -150vh;
			.sticky-wrapper {
				height: 100vh * 100% / $titleH;
				// height: 100vh;
			}
		}
		#conception {
			height: $concepH * $ratio1 * 1% / 1vh;
			top: $concepT * $ratio1 * 1% / 1vh;
			// height: 350vh;
			// top: -250vh;
			.bg_c2 {
				height: 100vh * 100% / $concepH;
				// height: 100vh;
			}
		}
		#conception-text {
			height: $conceptH * $ratio1 * 1% / 1vh;
			top: $conceptT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -400vh;
			.sticky-wrapper {
				height: 100vh * 100% / $conceptH;
				// height: 100vh;
			}
		}
		#imagination {
			height: $imgnH * $ratio1 * 1% / 1vh;
			top: $imgnT * $ratio1 * 1% / 1vh;
			// height: 350vh;
			// top: -500vh;
			.sticky-wrapper {
				height: 100vh * 100% / $imgnH;
				// height: 100vh;
			}
		}
		#imagination_title {
			height: $imgntH * $ratio1 * 1% / 1vh;
			top: $imgntT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -650vh;
			.sticky-wrapper {
				height: 100vh * 100% / $imgntH;
				// height: 100vh;
			}
		}
		#display {
			// height: $displayH1 * $ratio1 * 1% / 1vh;
			// top: $displayT * $ratio1 * 1% / 1vh;
			// height: 250vh;
			// top: -650vh;
			height: 100%;
			top: 0;
			.img-wrapper {
				// height: 100vh * 100% / $displayH1;
				// height: 100vh;
				height: 100%;
			}
			.series_display {
				// height: 150vh * 100% / $displayH1;
				// top: -100vh * 100% / $displayH1;
				// height: 150vh;
				// top: -100vh;
				height: 100%;
				top: -100%;
				.sticky-wrapper {
					// height: 100vh * 100% / $seridispH;
					// height: 100vh;
					height: 100%;
				}
			}
			.form-mask {
				height: 100vh * 100% / $displayH1;
				top: 150vh * 100% / $displayH1;
				// height: 100vh;
				// top: 150vh;
			}
			.reservation {
				height: 100vh * 100% / $displayH1;
				top: -100vh * 100% / $displayH1;
				// height: 100vh;
				// top: -100vh;
				.apiLoadingFrame {
					height: 100%;
					// height: 100vh;
				}
				.reservation-form {
					height: auto;
					max-height: 90%;
				}
			}
		}
	}
}
section {
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 500px;
	z-index: 50;
}
.text_en_bold {
	font-family: "BMWTypeNextLatinTT-Bold", serif;
	letter-spacing: 1.13px;
}
.text_en_regular {
	font-family: "BMWTypeNextLatinTT-Regular", serif;
}
.text_en_light {
	font-family: "BMWTypeNextLatinTT-Light", serif;
}
.text_en_thin {
	font-family: "BMWTypeNextLatinTT-Thin", serif;
}
.text_ch_heavy {
	font-family: arudjingxiheipe1xg30_hv, 微軟正黑體;
}
.text_ch_medium {
	font-family: arudjingxiheipe1xg30_md, 微軟正黑體;
}

.shine {
	background: linear-gradient(
		90deg,
		#707070 0%,
		rgba(255, 255, 255, 0.5) 12%,
		rgba(255, 255, 255, 1) 24%,
		#707070 36%
	);
	background-position: 0vw;
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	animation: shine 4s infinite linear forwards;
	z-index: 1000;
}
.shake {
	animation: shake 1.5s infinite ease forwards;
}
.hshake_right {
	animation: hShake_right 1.5s infinite ease forwards;
}
.hshake_right_sm {
	animation: hShake_right_sm 1.8s infinite ease forwards;
}
.hshake_left {
	animation: hShake_left 1.5s infinite ease forwards;
}
.sticky-wrapper {
	position: -webkit-sticky;
	position: sticky;
	top: 0px;
}

@keyframes shine {
	0% {
		background-position: 0vw;
	}
	// 90%
	// 	background-position: 73vw
	100% {
		background-position: 100vw;
	}
}

@keyframes shake {
	0% {
		transform: translateY(0px);
	}
	10% {
		transform: translateY(-5px);
	}
	20% {
		transform: translateY(0px);
	}
	30% {
		transform: translateY(-5px);
	}
	40% {
		transform: translateY(0px);
	}
	100% {
		transform: translateY(0px);
	}
}

@keyframes hShake_right {
	0% {
		transform: translateX(0px);
	}
	10% {
		transform: translateX(3px);
	}
	20% {
		transform: translateX(0px);
	}
	30% {
		transform: translateX(3px);
	}
	40% {
		transform: translateX(0px);
	}
	100% {
		transform: translateX(0px);
	}
}

@keyframes hShake_right_sm {
	0% {
		transform: translate(0px, -50%);
	}
	60% {
		transform: translate(0px, -50%);
	}
	70% {
		transform: translate(2px, -50%);
	}
	80% {
		transform: translate(0px, -50%);
	}
	90% {
		transform: translate(2px, -50%);
	}
	100% {
		transform: translate(0px, -50%);
	}
}

@keyframes hShake_left {
	0% {
		transform: translateX(0px);
	}
	10% {
		transform: translateX(-3px);
	}
	20% {
		transform: translateX(0px);
	}
	30% {
		transform: translateX(-3px);
	}
	40% {
		transform: translateX(0px);
	}
	100% {
		transform: translateX(0px);
	}
}

@media screen and (max-width: 1200px) {
	html {
		font-size: 8px;
	}
}
@media screen and (max-width: 768px) {
	html {
		font-size: 10px;
	}
	body {
		#app {
			width: 100%;
			height: 100%;
			main {
				// height: $mainH2 * 1% / 1vh;
				// height: 100%;
				#story {
					height: $storyH * $ratio2 * 1% / 1vh;
				}
				#title {
					height: $titleH * $ratio2 * 1% / 1vh;
					top: $titleT * $ratio2 * 1% / 1vh;
				}
				#conception {
					height: $concepH * $ratio2 * 1% / 1vh;
					top: $concepT * $ratio2 * 1% / 1vh;
				}
				#conception-text {
					height: $conceptH * $ratio2 * 1% / 1vh;
					top: $conceptT * $ratio2 * 1% / 1vh;
				}
				#imagination {
					height: $imgnH * $ratio2 * 1% / 1vh;
					top: $imgnT * $ratio2 * 1% / 1vh;
				}
				#imagination_title {
					height: $imgntH * $ratio2 * 1% / 1vh;
					top: $imgntT * $ratio2 * 1% / 1vh;
				}
				#display {
					// height: $displayH2 * $ratio2 * 1% / 1vh;
					// top: $displayT * $ratio2 * 1% / 1vh;
					// height: 100%;
					// top: 0;
					.form-mask {
						height: (100vh + $rwdHeight1) * 100% / $displayH2;
						top: 150vh * 100% / $displayH2;
						// height: 180vh
					}
					.reservation {
						height: (100vh + $rwdHeight1) * 100% / $displayH2;
						top: -100vh * 100% / $displayH2;
						// height: 180vh;
					}
				}
			}
		}
	}
}
</style>
